<template>
  <div class="content">
    <div class="md-layout">
      <div class="form">
        <md-card class="form-block">
          <md-card-content>
            <md-field>
              <label>App</label>
              <md-select
                id="app-select"
                v-model="selectedApp"
              >
                <md-option
                  v-for="app in apps"
                  :key="app"
                  :value="app"
                >
                  {{ app }}
                </md-option>
              </md-select>
            </md-field>

            <md-field>
              <label>App Version</label>
              <md-input
                v-model="appVersion"
                type="text"
              />
            </md-field>
            <p
              v-if="!appVersionValid"
              class="add-dialog-error"
            >
              should be valid semver format (1.1.0)
            </p>
          </md-card-content>
        </md-card>

        <md-card class="form-block">
          <md-card-content>
            <country-autocomplete
              label="Country Code"
              @countrySelected="onCountryChanged"
            />

            <md-field>
              <label>Latitude</label>
              <md-input v-model="latitude" />
            </md-field>
            <md-field>
              <label>Longitude</label>
              <md-input v-model="longitude" />
            </md-field>
          </md-card-content>
        </md-card>

        <md-card class="form-block">
          <md-card-content>
            <country-autocomplete
              label="Original Country Code"
              @countrySelected="onOriginalCountryChanged"
            />
          </md-card-content>
        </md-card>

        <md-card class="form-block">
          <md-card-content>
            <md-autocomplete
              ref="tagsSelect"
              v-model="selectTagValue"
              :md-options="tagsIndex"
              :md-fuzzy-search="false"
              @md-selected="addTag"
            >
              <label>Tags</label>

              <template
                slot="md-autocomplete-item"
                slot-scope="{ item, term }"
              >
                <md-highlight-text :md-term="term">
                  {{ item }}
                </md-highlight-text>
              </template>
            </md-autocomplete>

            <md-chip
              v-for="tag in tags"
              :key="tag"
              class="md-primary"
              md-deletable
              @click="deleteChip(tag)"
            >
              {{ tag }}
            </md-chip>
          </md-card-content>
        </md-card>

        <md-field>
          <md-button
            class="md-primary"
            :disabled="loading"
            @click="searchShortcuts()"
          >
            <md-progress-spinner
              v-if="loading"
              md-mode="indeterminate"
              md-diameter="16"
              md-stroke="4"
              class="md-primary"
            />
            <span v-else>Search</span>
          </md-button>
        </md-field>
      </div>

      <list-shortcuts-output
        :shortcuts.sync="shortcuts"
        @onInfoClick="displayDetailsDialog"
      />
    </div>

    <md-dialog :md-active.sync="showDetailsDialog">
      <md-dialog-title>Node configuration</md-dialog-title>
      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="showDetailsDialog = false"
        >
          Close
        </md-button>
      </md-dialog-actions>

      <md-dialog-content>
        <pre>{{ JSON.stringify(detailedShortcut, null, 4) }}</pre>

        <md-button
          class="md-primary"
          @click="showDetailsDialog = false"
        >
          Save
        </md-button>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>
<script>
    import { capitalCoordinates } from "@/assets/countries_iso/capital-coordinates.js";

    import { CountryAutocomplete, ListShortcutsOutput } from "@/components";
    import semver from "semver";

    export default {
        components: {
            CountryAutocomplete,
            ListShortcutsOutput
        },
        data() {
            return {
                apps: [],
                selectedApp: "",
                appVersion: "",
                appVersionValid: true,

                tagsIndex: [],
                tagsList: [],
                selectTagValue: "",
                tags: [],

                original_country_code: "",

                showDetailsDialog: false,
                detailedShortcut: {},

                componentKey: 0,
                showDialog: false,
                shortcuts: [],
                countryISOCode: "US",
                latitude: 0,
                longitude: 0,

                loading: false
            };
        },
        watch: {
            selectedApp() {
                if (this.selectedPlatform === "") {
                    this.selectedPlatform = this.platforms.find(p => this.selectedApp.toLowerCase().includes(p.toLowerCase()));
                }
            }
        },
        mounted() {
            this.loading = true;
            Promise.all([
                this.getApps(),
                this.getTags()
            ]).then(() => {
                this.loading = false;
            });
        },
        methods: {
            getApps() {
                return this.$http.get("/v1/admin/store/apps").then(res => {
                    this.apps = res.data.apps.map(a => a.identity);
                });
            },
            getTags() {
                return this.$http.get("/v1/tags").then(
                    res => {
                        let tagNames = [];

                        res.data.tags.forEach(el => tagNames.push(el.name));

                        this.tagsList = res.data.tags;
                        this.tagsIndex = tagNames;
                    },
                    err => {
                        console.error(err);
                    });
            },
            addTag(tag) {
                this.tags.push(tag);

                this.selectTagValue = "";
                this.$refs.tagsSelect.$data.searchTerm = "";
            },
            createTag(tag) {
                let body = {
                    tag: {
                        name: tag,
                        weight: parseInt(this.tagForm.weight, 10)
                    }
                };

                this.$http.post("/v1/tag/create", body).then(
                    res => {
                        console.log(res);
                        this.getTags();
                    },
                    err => {
                        console.error(err);
                    }
                );
            },
            deleteChip(item) {
                this.tags = this.tags.filter(el => {
                    return el !== item;
                });
            },
            searchShortcuts() {
                this.appVersionValid = true;
                if (!semver.valid(this.appVersion)) {
                    console.error("semver is invalid");
                    this.appVersionValid = false;
                    return;
                }

                let cleanVer =  semver.clean(this.appVersion);
                let body = {
                    app_identity: this.selectedApp,
                    location: {
                        countryCode: this.countryISOCode,
                        latitude: this.latitude,
                        longitude: this.longitude
                    },
                    original_country_code: this.original_country_code,
                    app_version: cleanVer,
                    tags: this.tags,
                };

                this.loading = true;
                this.$http.post("/v1/shortcuts/query", body).then(
                    res => {
                        this.shortcuts = res.data.shortcuts;
                        this.loading = false;
                    },
                    err => {
                        console.error(err);
                        this.loading = false;
                    },
                );
            },
            toggleNodeDialog() {
                this.showDialog = !this.showDialog;
            },
            onCountryChanged(countryCode) {
                this.countryISOCode = countryCode;

                const country = capitalCoordinates[countryCode];
                this.latitude = country.latitude;
                this.longitude = country.longitude;
            },
            onOriginalCountryChanged(countryCode) {
                this.original_country_code = countryCode;
            },
            displayDetailsDialog (shortcut) {
                this.showDetailsDialog = true;

                this.detailedShortcut = shortcut;
            }
        }
    };
</script>

<style scoped lang="scss">
    .md-layout {
      flex-direction: column;
    }

    .new-node-dialog {
        padding: 50px 100px;
    }

    .md-dialog-container {
        width: 1200px;
    }

    .shake-on-error .md-duplicated {
        animation-name: shake;
        animation-duration: 0.5s;
    }

    .form {
      margin: 0 auto;
      min-width: 400px;
      display: flex;
      flex-direction: column;
    }

    .form-block {
      max-width: 500px;
    }

    @keyframes shake {
        0% {
            transform: translate(15px);
        }
        20% {
            transform: translate(-15px);
        }
        40% {
            transform: translate(7px);
        }
        60% {
            transform: translate(-7px);
        }
        80% {
            transform: translate(3px);
        }
        100% {
            transform: translate(0px);
        }
    }
</style>

<style lang="css">
    .pulse-on-error >>> .md-duplicated {
        animation-name: pulse;
        animation-duration: 0.5s;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        animation-timing-function: ease-in-out
    }

    @keyframes pulse {
        0% {
            transform: scale(1.1, 1.1);
        }
        100% {
            transform: scale(0.9, 0.9);
        }
    }

    .md-layout {
        padding: 0 50px;
    }

    .form-checkbox label {
        top: 10px !important;
    }

    .md-toolbar + .md-toolbar {
        margin-top: 16px;
    }
</style>
